import React from "react";
import { ArrowRight } from "lucide-react";

const base =
  "inline-flex items-center justify-center gap-2 font-medium rounded-full transition duration-300 hover:scale-[1.03] active:scale-[0.97] focus:outline-none focus-visible:ring-2 focus-visible:ring-kern-terracotta focus-visible:ring-offset-2 focus-visible:ring-offset-kern-bg";

const variants = {
  primary: "bg-kern-terracotta text-kern-bg hover:bg-[#b98771]",
  olive: "bg-kern-olive text-kern-bg hover:bg-[#5f6455]",
  light: "bg-white text-kern-dark hover:bg-[#f3efe6] shadow-[0_8px_30px_rgba(79,80,72,0.08)]",
  outline: "bg-transparent text-kern-terracotta border border-kern-terracotta/50 hover:bg-kern-terracotta/10",
};

export const Button = ({
  children,
  variant = "primary",
  size = "md",
  arrow = true,
  as = "a",
  className = "",
  ...props
}) => {
  const sizing = size === "lg" ? "px-8 py-4 text-base" : "px-6 py-3 text-sm";
  const Comp = as;
  return (
    <Comp className={`${base} ${variants[variant]} ${sizing} ${className}`} {...props}>
      {children}
      {arrow && <ArrowRight size={16} strokeWidth={2} />}
    </Comp>
  );
};
